import { ProgrammaticAndDirectSalesBookingStatus } from 'components/common/types/Deal.types';
import { DirectSalesStatusOption } from 'components/common/types/DirectSalesCampaign.types';
import { LIVE_CAMPAIGN_STATUSES } from 'consts/campaignStatus';

export const isLineLiveOrEnded = (lineStatus: ProgrammaticAndDirectSalesBookingStatus): boolean => {
  return LIVE_CAMPAIGN_STATUSES.includes(lineStatus as DirectSalesStatusOption);
};
